

import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import VTooltip from 'v-tooltip'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSocketIO from 'vue-socket.io'
// import VueYouTubeEmbed from 'vue-youtube-embed'
import 'video.js/dist/video-js.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import 'default-passive-events'

// 共用 function
import global_function from './global_function'// 引用
Vue.use(global_function) // 將全域性函式當做外掛來進行註冊

Vue.use(Viewer)
// Vue.use(VueYouTubeEmbed)

// const gtm = require('@/plugins/gtm/datalayer').default();

// // 確保 routerBeforeEach 存在
// if (gtm.userStateDataLayer.routerBeforeEach) {
//   gtm.userStateDataLayer.routerBeforeEach(router);
// } else {
//   console.error('routerBeforeEach is not defined in methodsToBeExposed');
// }
const SocketInstance = {
  // 初始化 socket 連接
  init() {
    const socketConnection =  new VueSocketIO({
      connection: `${process.env.SOCKET_API}ccbot-health`
    })
    // 安裝到 Vue 實例
    Vue.use(socketConnection)
    Vue.prototype.sockets = socketConnection
  },
}
Vue.prototype.$socketManager = SocketInstance


// const url = window.location.hash.split('#/')[1]
// console.log(url)
// const WHITELIST = ['jinfm', 'tickets', 'udesign', 'eip', 'health']
// WHITELIST.forEach(id => {
//   // console.log(process)
//   if (url.includes(id)) {
//     // console.log(id)
//     // Socket io :: 關閉。待有需求時候再行開啟
//     Vue.use(
//       new VueSocketIO({
//         // connection: 'http://localhost:80/ccbot-jinfm',
//         // connection: process.env.SOCKET_API
//         connection: `${process.env.SOCKET_API}ccbot-${id}`
//       })
//     )
//   }
// })


Vue.use(VueAxios, axios)

// Vue.use(VTooltip)

Vue.config.productionTip = false

// https://www.npmjs.com/package/vue-uuid
import UUID from 'vue-uuid'
Vue.use(UUID)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js